import { api, buildQueryString } from '../core';

interface timelineGetDownloadResponse {
  downloadPath: string | null;
  downloadToken: string | null;
}

type timelineGetDownloadProps = {
  caseId: string;
};

const timelineGetDownloadApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getTimelineGetDownload: builder.query<timelineGetDownloadResponse, timelineGetDownloadProps>({
      query: (params: timelineGetDownloadProps) => {
        const queryString = buildQueryString(params);

        return {
          url: `timeline/get-download?${queryString}`,
          method: 'GET'
        };
      },
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Get was aborted');
          } else {
            console.error('Error in getTimelineGetDownload in onQueryStarted:', error);
          }
        }
      }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyGetTimelineGetDownloadQuery } = timelineGetDownloadApi;
